const resetWhenLocationTypeVacantLand = (location) => {
    if (location.locationType.value !== undefined && location.locationType.value.code === 'VacantLand') {
        location.residenceType.value = undefined;
        location.dwellingOccupancy.value = undefined;
        location.dwellingUsage.value = undefined;
    }
};


export default {
    resetWhenLocationTypeVacantLand: resetWhenLocationTypeVacantLand
};